import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SharingService } from 'src/app/modules/shared/shared.service';

import { DecimalPipe, CurrencyPipe, formatDate, DatePipe } from '@angular/common';
@Component({
  selector: 'app-selected-client',
  templateUrl: './selected-client.component.html',
  styleUrls: ['./selected-client.component.css']
})
export class SelectedClientComponent implements OnInit, OnDestroy {



  ClientName: string;
  ClientNo: string;
  Year: any;
  FromDate: any;
  ToDate: any;
  selectedFormData: any;
  BranchNo = [];
  ContractNo: any;
  isFormSelected: boolean = false;


  constructor(private sharingService: SharingService, private pipe: DatePipe) { }


  ngOnInit(): void {

    if (sessionStorage.getItem("selectedFormData") !== '') {
      this.selectedFormData = JSON.parse(sessionStorage.getItem("selectedFormData"));
    }
    this.ClientName = sessionStorage.getItem("ClientName");
    this.ClientNo = sessionStorage.getItem("ClientNo");
    this.Year = sessionStorage.getItem("Year");
    if (this.selectedFormData) {
      this.isFormSelected = true;
      // this.selectedFormData.PeriodeDebut = '20200101';
      var fromDate = this.selectedFormData.PeriodeDebut;
      if (fromDate != null && fromDate != '') {
        if (fromDate.length !== 10) {
          this.FromDate = this.formatDate(fromDate);
        }
        else {
          this.FromDate = fromDate;
        }
      }
      var toDate = this.selectedFormData.PeriodeFin;
      if (toDate != null && toDate != '') {
        if (toDate.length !== 10) {
          this.ToDate = this.formatDate(toDate);
        }
        else {
          this.ToDate = toDate;
        }
      }
      if (this.selectedFormData.contrat) {
        this.selectedFormData.contrat.forEach(element => {
          if ((element !== '') && (element != null)) {
            if (element.NrBranche != '' && element.NoContrat != '')
              this.BranchNo.push(element);
          }
        });
      } else {
        this.selectedFormData.Contrat.forEach(element => {
          if ((element !== '') && (element != null)) {
            if (element.NrBranche != '' && element.NoContrat != '')
              this.BranchNo.push(element);
          }
        });
      }
    }
  }
  formatDate(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var day = date.substring(10, 8);
        var month = date.substring(7, 5);
        var year = date.substring(0, 4);
      } else {
        var day = date.slice(date.length - 2);
        var month = date.substring(6, 4);
        var year = date.substring(0, 4);
      }
      return [day, month, year].join('/');
    } else {
      return null;
    }
  }
  // transform(date) {
  //   if (date !== '' && date !== null) {

  //     var day = date.slice(date.length - 2);
  //     var month = date.substring(7, 5);
  //     var year = date.substring(4, 0);

  //     return [day, month, year].join('/');
  //   } else {
  //     return null;
  //   }
  // }

  ngOnDestroy(): void {
  }

}
